import { JobPost } from "@prisma/client";
import { getIsApproved } from "./getIsApproved";
import { getIsExpired } from "./getIsExpired";
import { getIsPaid } from "./getIsPaid";
import { getIsPublished } from "./getIsPublished";
import { getIsStopped } from "./getIsStopped";

export enum JobPostCompositeStatus {
  DRAFT = "DRAFT",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  APPROVED = "APPROVED",
  PUBLISHED = "PUBLISHED",
  STOPPED = "STOPPED",
  EXPIRED = "EXPIRED",
}

export const getCompositeStatus = (jobPost: JobPost) => {
  const isPaid = getIsPaid(jobPost);
  const isApproved = getIsApproved(jobPost);
  const isPublished = getIsPublished(jobPost);
  const isStopped = getIsStopped(jobPost);
  const isExpired = getIsExpired(jobPost);

  return isExpired
    ? JobPostCompositeStatus.EXPIRED
    : isStopped
    ? JobPostCompositeStatus.STOPPED
    : isPublished
    ? JobPostCompositeStatus.PUBLISHED
    : isApproved
    ? JobPostCompositeStatus.APPROVED
    : isPaid
    ? JobPostCompositeStatus.PENDING_APPROVAL
    : JobPostCompositeStatus.DRAFT;
};
